import { makeStyles } from '@material-ui/core/styles';

type StyleProp = {
    multiplier: number;
    arrowsOut: boolean;
};

export const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: '100%',
        flexGrow: 1,
    },
    titleContainer: {
        position: 'absolute',
        top: '18px',
        width: '100%',
        zIndex: 5,
        textAlign: 'center',
    },
    title: {
        backgroundColor: 'rgba(255,255,255,0.6)',
        padding: '0.25rem',
    },
    imgContainer: (props: StyleProp) => ({
        display: 'block',
        maxWidth: '100%',
        overflow: 'hidden',
        width: '100%',
        height: `${props.multiplier === 1 ? '185px' : '388px'}`
    }),
    img: {
        width: '100%',
    },
    embed: {
        width: '100%',
        height: '100%',
    },
    sliderContianer: {
        position: 'relative',
    },
    prevButton: (props: StyleProp) => ({
        position: 'absolute',
        backgroundColor: theme.palette.primary.main,
        width: `${16 * props.multiplier}px`,
        height: `${32 * props.multiplier}px`,
        left: props.arrowsOut ? '-0.5rem' : 0,
        minWidth: `${16 * props.multiplier}px`,
        padding: 0,
        color: '#ffffff',
        borderRadius: 0,
        top: '50%',
        marginTop: `-${16 * props.multiplier}px`,
        opacity: '0.64',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            opacity: 1,
        },
    }),
    nextButton: (props: StyleProp) => ({
        position: 'absolute',
        backgroundColor: theme.palette.primary.main,
        width: `${16 * props.multiplier}px`,
        height: `${32 * props.multiplier}px`,
        right: props.arrowsOut ? '-0.5rem' : 0,
        minWidth: `${16 * props.multiplier}px`,
        padding: 0,
        color: '#ffffff',
        borderRadius: 0,
        top: '50%',
        marginTop: `-${16 * props.multiplier}px`,
        opacity: '0.64',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            opacity: 1,
        },
    }),
    indicatorContainer: (props: StyleProp) => ({
        position: 'absolute',
        width: '100%',
        bottom: `${props.multiplier === 1 ? '5' : '10'}px`
    }),
    indicator: (props: StyleProp) => ({
        width: `${8 * props.multiplier}px`,
        height: `${8 * props.multiplier}px`,
        margin: '0 2px',
        borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255.26)',
        cursor: 'pointer',
        border: '2px solid #283686',
    }),
    selected: () => ({
        backgroundColor: theme.palette.primary.main
    }),
    numberContainer: {
        position: 'absolute',
        bottom: '10px',
        right: '75px',
        backgroundColor: '#283686',
        color: '#ffffff',
        paddingLeft: '0.5rem',
        paddingRight: '0.5rem',
        paddingTop: '0.12rem',
        paddingBottom: '0.12rem',
        '@media (max-width: 720px)': {
            right: 'unset',
        },
    },
    sourceContainer: {
        position: 'absolute',
        bottom: '10px',
        left: '75px',
        backgroundColor: '#283686',
        color: '#ffffff',
        paddingLeft: '0.5rem',
        paddingRight: '0.5rem',
        paddingTop: '0.12rem',
        paddingBottom: '0.12rem',
    },
}));
